import React, {Component} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Cell, Legend, Pie, PieChart, Tooltip} from 'recharts'
import {Card, Select} from 'antd'
import _ from 'lodash'


import Request from '../../request'

import {connect} from 'react-redux'

// const {RangePicker} = DatePicker
const {Option} = Select

const data = [
    {name: 'Group A', value: 525},
    {name: 'Group B', value: 175}
]


const COLORS = ['#FFFF00', '#87ceeb']

const RADIAN = Math.PI / 180
const renderCustomizedLabel = ({
                                   cx, cy, midAngle, innerRadius, outerRadius, percent, index
                               }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)

    return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    )
}

class UserWiseReport extends Component {
    getGraphData = () => {

        let {userBranch, userId} = this.state
        let obj = {userBranch, userId}

        Request.userwiseReportData({filters: obj}).then(({data: chartData}) => {

            this.setState({chartData})
        })
    }

    constructor(props) {
        super(props)
        //  this.loadUsers()
        this.loadBranches()
        this.state = {
            loading: false,
            allUsers: [],
            allBranches: []
        }
    }

    async loadUsers() {
        let {userBranch} = this.state
        let {data: userLists} = await Request.loadUser({results: 10000, userBranch})
        let userList = []
        _.each(userLists, (item) => {
            userList.push({value: item._id, text: item.name})
        })
        this.setState({allUsers: userList})
    }

    async loadBranches() {
        let {data: branchData} = await Request.loadBranch({results: 10000})
        let branchList = []
        _.each(branchData, (item) => {
            branchList.push({value: item._id, text: item.branchName})
        })
        this.setState({allBranches: branchList})
    }


    componentDidMount() {

    }

    render() {

        const {allBranches, allUsers, chartData} = this.state

        return (
            <PageHeaderWrapper title={'UserWise Graphical Report'}>
                <Card style={{marginBottom: 10}}>
                    <Select
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        style={{
                            width: 225,
                            marginRight: 16
                        }}
                        value={this.state.userBranch}
                        placeholder="All Branch"
                        onChange={branchId => {
                            this.setState(
                                {
                                    userBranch: branchId && branchId.toString(),
                                    userId: ''
                                },
                                () => {
                                    this.loadUsers()
                                }
                            )
                        }}>
                        {allBranches.map((val, idn) => {
                            return (
                                <Option key={idn} value={val.value}>
                                    {val.text}
                                </Option>
                            )
                        })}
                    </Select>
                    <Select
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        value={this.state.userId}
                        placeholder="All Users"
                        style={{
                            width: 225
                        }}
                        onChange={userId => {
                            this.setState(
                                {
                                    userId: userId && userId.toString()
                                },
                                () => {
                                    this.getGraphData()
                                }
                            )
                        }}>
                        {allUsers.map((val, idn) => {
                            return (
                                <Option key={idn} value={val.value}>
                                    {val.text}
                                </Option>
                            )
                        })}
                    </Select>
                </Card>


                {chartData && <Card bordered={true}>

                    <PieChart width={1000} height={420}>
                        <Pie
                            data={chartData}
                            cx={500}
                            cy={200}
                            labelLine={false}
                            label={renderCustomizedLabel}
                            outerRadius={200}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {
                                data.map((entry, index) => <Cell key={`cell-${index}`}
                                                                 fill={COLORS[index % COLORS.length]}/>)
                            }
                        </Pie>
                        <Legend wrapperStyle={{position: 'relative'}}/>
                        <Tooltip/>
                    </PieChart>
                </Card>}
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserWiseReport)
